<template>
    <div class="block-main">
        <router-view></router-view>
    </div>
</template>

<script>
window._AMapSecurityConfig = {
  securityJsCode: "a6c95f2d49553768ccd84ab100783147",
};
export default {
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/dataIndex/index.scss";
</style>